var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGeolocation = function SvgIconGeolocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#04000D",
    strokeLinejoin: "round",
    strokeWidth: 2.75,
    d: "M22 3.68 2 9.645l7.943 3.285 1.292 9.108z"
  })));
};
export { SvgIconGeolocation as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI0IDI1IiBmaWxsPSJub25lIj48cGF0aCBkPSJNMjIgMy42ODAxOEwyIDkuNjQ1MDhMOS45NDI4MyAxMi45MzAzTDExLjIzNDYgMjIuMDM3NUwyMiAzLjY4MDE4WiIgc3Ryb2tlPSIjMDQwMDBEIiBzdHJva2Utd2lkdGg9IjIuNzUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";